module.exports = __webpack_public_path__ + "img/icon-head-def@3x.498eda64.png";